/**
 * Сервис для работы с логами
 */
export default class LogService {

    private logs: {[key:string]: Array<string>} = {
        game: [],
    };

    private readonly GAME_LOGS = 'game';

    /**
     * Логи игры
     */
    public get gameLogs(): Array<string>
    {
        return this.logs[this.GAME_LOGS];
    }

    /**
     * Добавить лог игры
     * @param log
     */
    public addGameLog(log: string): void
    {
        this.addLog(log, this.GAME_LOGS);
    }

    /**
     * Добавить лог
     * @param log
     * @param type
     * @private
     */
    private addLog(log: string, type: string): void
    {
        if (typeof this.logs[type] === 'undefined') {
            return;
        }

        if (this.logs[type].length >= 5000) {
            this.logs[type].shift();
        }

        this.logs[type].push(log);
    }
}
